import { httpsCallable } from 'firebase/functions';

import { functions } from './firebase';
import { getSlackSharedSecret } from './env';
import type { InvitationSlackPayload, InviteRequestValues } from '../types';

/**
 * Formats a request invite form submission for Slack.
 */
export function formatInviteSlackMessage(values: InviteRequestValues): string {
  return `Beta invitation requested:\n${values.name} ${values.email}\n${values.about}`;
}

/**
 * Sends a beta invitation request to the Slack bridge callable.
 */
export async function requestInvite(values: InviteRequestValues): Promise<void> {
  const payload: InvitationSlackPayload = {
    message: formatInviteSlackMessage(values),
    secret: getSlackSharedSecret(),
  };
  const postSlackMessage = httpsCallable<InvitationSlackPayload, void>(functions, 'postSlackMessage');
  await postSlackMessage(payload);
}
